<mat-form-field style="width:100%;">
    <input matInput [placeholder]="placeholder" [(ngModel)]="inputValue">
    <mat-icon matSuffix>search</mat-icon>
</mat-form-field>